import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactModal from 'react-modal'
import ReactTooltip from 'react-tooltip'
import classnames from 'classnames'
import Joyride, { ACTIONS, STATUS } from 'react-joyride'
// import isWindows from 'is-windows'

import MalletStationBarsLearn from './MalletStationBarsLearn'
import LearnModeSteps from './LearnModeSteps'
import LearnModeBarInfo from './LearnModeBarInfo'
import LearnModeOptions from './LearnModeOptions'
import LearnModeSettings from './LearnModeSettings'
import tourSteps from './LearnModeTour'

import Button from './UI/Button'

import tooltips from '../constants/tooltips.json'

import {
  enterNormalMode,
  enterLearnMode,
  closeLearnMode,
  requestAllDeviceData,
  selectLearnBar,
  setLearnModeRecord,
  setLearnModeStrikeType,
  setLearnStrikeCount,
  setAutoLearnMode,
  resetLearnModeRecords,
  learnModeComplete,
  openLearnModeTour
} from '../actions'

class LearnMode extends Component {
  componentDidUpdate() {
    const learnModeRecording = this.props.learnModeRecording

    // Learn Mode Open: when recording
    if(learnModeRecording) {
      if (window.malletStation.deviceMode !== 'learn') {
        console.log(">> Enter Bar Regulation 🍺 🍺 🍺");
        this.props.onEnterLearnMode()
      }
    } else {
      // when not recording switch to normal mode
      if (window.malletStation.deviceMode !== 'normal') {
        console.log(">> Exiting Bar Regulation 🍻 🏡");
        this.props.onEnterNormalMode();
      }
    }
  }

  handleCloseModal = () => {
    // this.props.onEnterNormalMode()
    this.props.onCloseLearnMode()
    this.props.onSelectBar(this.props.learnModeAuto ? 0 : -1)
    this.props.onSetLearnModeRecord(false)
    this.props.onResetStrikeType()
    this.props.onResetLearnModeRecords()
    this.props.onOpenLearnModeTour(false)
    this.props.onLearnModeComplete(false)
  }

  afterOpenModal = () => {
    ReactTooltip.rebuild();
    // open tour
    if (this.props.showLearnModeTour) {
      this.props.onOpenLearnModeTour(true);
    }
    // reset records
    // TODO: check if this is desired
    this.props.onResetStrikeCount();
    this.props.onResetLearnModeRecords();

    // request & store: [avgHighs, avgLows,lowMults, highMults]
    this.props.onRequestDeviceData();
  }

  handleJoyrideCallback = (data) => {
    const { action, status } = data;
    // close on 'X' button
    if (action === ACTIONS.CLOSE && this.props.learnModeTourOpen) {
      this.props.onOpenLearnModeTour(false)
    }
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      this.props.onOpenLearnModeTour(false)
    }
  }

  render() {
    const {
      learnModeOpen,
      learnModeTourOpen,
      learnModeRecording,
      learnModeComplete,
      showTooltips
    } = this.props
    
    return (
      <div className="learn-mode-modal">
        <ReactModal
          isOpen={learnModeOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.handleCloseModal}
          shouldCloseOnOverlayClick={false}
          className="react-modal"
          overlayClassName="react-modal-overlay"
          contentLabel="Learn Mode"
        >
          <Joyride
            steps={tourSteps}
            showOverlay={true}
            showSkipButton={true}
            showStepsProgress={true}
            continuous={true}
            run={learnModeTourOpen}
            callback={this.handleJoyrideCallback}
            styles={{
              buttonClose: {
                display: "block",
              },
              options: {
                arrowColor: "#2d2d2d",
                backgroundColor: "#2d2d2d",
                textColor: "#efefef",
                borderColor: "#04aef0",
                primaryColor: "#04aef0",
              },
            }}
          />
          <div
            className={classnames(
              "learn-mode-editor",
              { recording: learnModeRecording },
              { complete: learnModeComplete }
            )}
          >
            <div
              className="learn-mode-buttons"
              data-tip={tooltips["editor-learn-modes-curves"]}
              data-multiline="true"
              data-place="bottom"
              data-tip-disable={!showTooltips}
            >
              <Button
                name="X"
                onClick={this.handleCloseModal}
                data-tip={tooltips["learn-mode-close"]}
                data-multiline="true"
                data-place="left"
                data-tip-disable={!showTooltips}
              />
            </div>
            <LearnModeSettings />
            <MalletStationBarsLearn />
            <div className="learn-mode-controls">
              <LearnModeBarInfo />
              <LearnModeSteps />
              <LearnModeOptions />
            </div>
          </div>
        </ReactModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    learnModeOpen: state.editor.learnModeOpen,
    learnModeTourOpen: state.editor.learnModeTourOpen,
    learnModeAuto: state.editor.learnModeAuto,
    learnModeRecording: state.editor.learnModeRecording,
    learnModeComplete: state.editor.learnModeComplete,
    showLearnModeTour: state.editorPreferences.showLearnModeTour,
    showTooltips: state.editorPreferences.showTooltips
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onEnterNormalMode: () => {
      dispatch(enterNormalMode())
    },
    onEnterLearnMode: () => {
      dispatch(enterLearnMode())
    },
    onRequestDeviceData: () => {
      dispatch(requestAllDeviceData())
    },
    onSelectBar: (bar) => {
      dispatch(selectLearnBar(bar))
    },
    onSetLearnModeRecord: (recording) => {
      dispatch(setLearnModeRecord(recording))
    },
    onResetStrikeCount: () => {
      dispatch(setLearnStrikeCount(true))
    },
    onResetStrikeType: () => {
      dispatch(setLearnModeStrikeType('soft'))
    },
    onSetAutoMode: (autoMode) => {
      dispatch(setAutoLearnMode(autoMode))
    },
    onResetLearnModeRecords: () => {
      dispatch(resetLearnModeRecords())
    },
    onCloseLearnMode: () => {
      dispatch(closeLearnMode())
    },
    onLearnModeComplete: (complete) => {
      dispatch(learnModeComplete(complete))
    },
    onOpenLearnModeTour: (state) => {
      dispatch(openLearnModeTour(state))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LearnMode)
